import { Suspense, lazy } from "react";
import { RechargeSkeleton } from "./RechargeSkeleton";
import Phone from '../../assets/images/HandPhone.webp';
import DotsGrid from './DotsGrid';
import { classNames } from "../../utils/common";
const Recharge = lazy(() => import("./Recharge"));

export const HeroRechargeCard = ({
  className = '',
  contentClassName = '',
  expandContacts = false,
}) => {
  return (
    <div className={classNames("w-full", className)}>
      <div className={classNames("w-full", contentClassName)}>
        <Suspense fallback={<RechargeSkeleton />}>
          <Recharge expandContacts={expandContacts} />
        </Suspense>
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <>
      {/* Mobile: use LoginBackground */}
      <div
        className="relative rounded-3xl mx-auto max-w-7xl bg-cover bg-center shadow-lg px-6 py-0 pt-10 -mt-8 mb-5 md:hidden bg-gradient-to-br from-[#73b7b5] via-[#7fbdaf] to-[#e0e87f]"
      >
        <div className="pt-10 max-w-6xl pb-8 relative">
          <HeroRechargeCard />
        </div>
        {/* phone image stays hidden on mobile as before */}
      </div>

      {/* Desktop / md+: use HeroBackground (original layout) */}
      <div
        className="hidden md:block overflow-hidden relative rounded-3xl m-10 bg-cover bg-center shadow-lg px-6 py-2 lg:flex lg:items-center lg:gap-x-10 lg:px-8 md:py-0 mb-5 bg-gradient-to-br from-[#73b7b5] via-[#7fbdaf] to-[#e0e87f]"
      >
        <div className="pt-40 lg:mt-0 w-[600px] md:pb-24 lg:flex lg:gap-x-10 pb-8 xl:pl-10 relative z-10">
          <HeroRechargeCard />

        </div>
        <DotsGrid className="absolute bottom-40 left-3/4 lg:left-96 xl:left-[450px] opacity-60 pointer-events-none z-0" />
        <img
          src={Phone}
          alt="Phone"
          className="hidden lg:block absolute -right-40 xl:right-10 bottom-0 max-w-lg w-auto lg:max-w-4xl xl:scale-110 scale-100 origin-bottom h-auto object-contain pointer-events-none"
        />
      </div>
    </>
  );
}
